import React from 'react';
import { createPortal } from 'react-dom';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import styled, { css } from 'styled-components';

import { IconWarning } from '../../easyclaim.app.assets/index';
import { ServiceError } from '../../easyclaim.app.services/EasyClaimServiceError';
import { FadeInBottom } from '../animations/FadeInBottom';
import { Modal } from '../common/Modal';
import { Slider } from './Slider';

interface ApiErrorModalProps {
	isOpen: boolean;
	serviceError?: ServiceError;
	onClose: () => void;
	intl: IntlShape;
	useSolvdStyles?: boolean;
}

interface ApiErrorModalState {}

export class ApiErrorModal extends React.Component<ApiErrorModalProps, ApiErrorModalState> {
	constructor(props: ApiErrorModalProps) {
		super(props);

		this.state = {};
	}

	render() {
		const content = (
			<Container>
				<StyledWarningIcon />
				<Paragraph>
					<FormattedMessage id="serviceErrorModal.paragraph.first" />
					<br />
					<br />
					<FormattedMessage id="serviceErrorModal.paragraph.second" />
					<br />
					<br />
					<FormattedMessage id="serviceErrorModal.paragraph.details" />
				</Paragraph>
			</Container>
		);

		if (this.props.useSolvdStyles) {
			return createPortal(
				<Slider
					isOpen={this.props.isOpen}
					onClose={this.props.onClose}
					title={<FormattedMessage id="serviceErrorModal.headline" />}
				>
					{content}
					<SliderActions>
						<button onClick={this.props.onClose}>
							<FormattedMessage id="serviceErrorModal.close" />
						</button>
					</SliderActions>
				</Slider>,
				document.body
			);
		}

		return (
			<Modal
				isOpen={this.props.isOpen}
				closeOnBackdropClick={true}
				onClose={this.props.onClose}
				header={
					<h2>
						<FormattedMessage id="serviceErrorModal.headline" />
					</h2>
				}
				footer={
					<button onClick={this.props.onClose}>
						<FormattedMessage id="serviceErrorModal.close" />
					</button>
				}
			>
				{content}
			</Modal>
		);
	}
}

export default injectIntl(ApiErrorModal);

const Key = styled.div`
	font-weight: bold;
	text-decoration: uppercase;
`;

const Value = styled.div``;

const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

const SliderActions = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 1rem;
`;

const StyledWarningIcon = styled(IconWarning)`
	height: 4rem;
	margin: 0 auto 2rem auto;
	vertical-align: text-bottom;
	color: ${(p) => p.theme.colors.danger};
	animation: ${css`
			${FadeInBottom}`} 0.6s cubic-bezier(0.39, 0.575, 0.565, 1) forwards;
`;

const Paragraph = styled.p`
	margin-bottom: 1rem;
	hyphens: auto;
`;

const Details = styled.div`
	display: flex;
	flex-direction: column;
	font-family: monospace, monospace;
	font-size: 0.95em;
`;

const Detail = styled.div`
	&:not(:last-child) {
		margin-bottom: 0.5rem;
	}
`;
